"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cardStyles = void 0;
exports.cardStyles = {
    root: function () {
        return {
            borderRadius: "4px",
        };
    },
};
//# sourceMappingURL=card-styles.js.map